module.exports = __webpack_public_path__ + "media/images/lilica/lilica1-21d24c839adfe4473c59d63fdd63d795.png";